var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];
var weekDay = ["Mån", "Tis", "Ons", "Tor", "Fre", "Lör", "Sön" ];

class DateTime
{
    static formatDate(dateString, format)
    {
        const date = this.getUTCDate(dateString);

        switch (format)
        {
            case 'hh:mm':
                return this.getTime(date);
            case 'yyyy-mm-dd':
                return this.getDate(date);
            case 'yyyy-mm-dd hh:mm':
                return `${this.getDate(date)} ${this.getTime(date)}`;
            default:
                return `${this.getDate(date)} ${this.getTime(date)}`;
        }
    }

    static getUTCDate(dateString)
    {
        // replace - with / in dateString for browser compatibility.
        dateString = dateString.replace(/-/g, "/");

        // Entries that come via socket have a date then a dot followed by a 6 digit number that should not be in the date
        dateString = dateString.split('.')[0];

        /*
        * The date we get from the server is UTC time.
        * We need to add UTC to the end of date_created
        * so that the Date function will convert it to
        * the UTC time that the browser is using.
        */
        const dateStringUTC = dateString + ' UTC';

        return new Date(dateStringUTC);
    }

    static getTimestamp(dateString)
    {
        return this.getUTCDate(dateString).getTime();
    }

    static getTime(date)
    {
        const hours = this.padDate(date.getHours());
        const minutes = this.padDate(date.getMinutes());
        return `${hours}:${minutes}`;
    }

    static getDate(date)
    {
        const year = date.getFullYear();
        const month = this.padDate(date.getMonth() + 1);
        const day = this.padDate(date.getDate());
        return `${year}-${month}-${day}`;
    }

    static padDate(number)
    {
        number = String(number);

        if (number.length === 1)
        {
            number = `0${number}`;
        }

        return number;
    }

    static isToday(dateString)
    {
        const date = this.getUTCDate(dateString);

        const today = new Date();

        return today.toDateString() === date.toDateString();
    }

    static getDiffTime(here, there){
        let hereDate = this.getUTCDate(here);
        let thereDate = this.getUTCDate(there);
        return Math.abs(hereDate - thereDate);
    }
    static getDiffMinutes(here, there){
        return Math.ceil(this.getDiffTime(here,there)/(1000*60));
    }

    static getDetailedNiceDate(dateString)
    {
        const date = this.getUTCDate(dateString);
        const today = new Date()
        if (this.isToday(dateString))
            return this.getTime(date);

        const weekDate = date.getDay()
        const month = date.getMonth()

        var timeDiff = Math.abs(today.getTime() - date.getTime());
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        if (diffDays === 1)
            return "Igår " + this.getTime(date);
        if (diffDays < 7)
            return `${weekDay[weekDate-1]} ${this.getTime(date)}`;
        return `${date.getDate()} ${monthNames[month]} ${this.getTime(date)}`;
    }
}

export default DateTime;



// WEBPACK FOOTER //
// ./common/js/lib/DateTime.js